import NavMegaMenu, { MenuColumn, MenuItem, MenuFooter, MenuFooterLink } from '@/components/layout/NavMegaMenu';

type DataNavDropdownProps = {
  active: boolean
}

// Content for the "Data" nav menu: the collections we publish for bulk download,
// the online tools for querying the data live, and the global coverage we draw
// from. The interaction mechanics live in NavMegaMenu.
export default function DataNavDropdown({ active }: DataNavDropdownProps) {
  return (
    <NavMegaMenu
      label="Data"
      href="/research/"
      active={active}
      footer={
        <MenuFooter label="Topical">
          <MenuFooterLink href="/datasets/sanctions/">Consolidated Sanctions</MenuFooterLink>
          <MenuFooterLink href="/datasets/securities/">Securities</MenuFooterLink>
          <MenuFooterLink href="/datasets/maritime/">Maritime</MenuFooterLink>
          <MenuFooterLink href="/datasets/kyb/">Know Your Business</MenuFooterLink>
          <MenuFooterLink href="/datasets/">More…</MenuFooterLink>
        </MenuFooter>
      }
    >
      <MenuColumn heading="Bulk data">
        <MenuItem href="/datasets/default/" title="OpenSanctions Default" desc="Sanctions, regulatory and PEP combined dataset" />
        <MenuItem href="/pep/" title="Politically Exposed Persons" desc="Political office-holders and their close associates" />
      </MenuColumn>
      <MenuColumn heading="Do it live">
        <MenuItem href="/research/" title="Entity search" desc="Look up people, companies, vessels & more" />
        <MenuItem href="/advancedsearch/" title="Screening tool" desc="Match against our multi-property matcher" />
      </MenuColumn>
      <MenuColumn heading="Global coverage">
        <MenuItem href="/datasets/sources/" title="Browse all data sources" desc="Primary sources from around the world" />
        <MenuItem href="/programs/" title="Sanctions programs" desc="Regimes & authorities behind the lists" />
      </MenuColumn>
    </NavMegaMenu>
  );
}
